<div class="container card">

  <h1 class="text-center header rounded mb-4" *ngIf="showHeading">Intervention Report</h1>
  <br>
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
        <input matEndDate placeholder="End date" [(ngModel)]="endDate">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

<!--    <mat-form-field appearance="outline" class=" col-md-4">-->
<!--      <mat-label>Select Centre</mat-label>-->
<!--      <mat-select [(ngModel)]="selectedCentreCode" multiple>-->
<!--        <mat-option *ngFor=" let c of (_centres$|async) "-->
<!--                    [value]="c.centreCode">{{c.centreName}} </mat-option>-->
<!--        &lt;!&ndash;      <mat-option  value="All">All Centres</mat-option>&ndash;&gt;-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select Centre</mat-label>

      <mat-select [(ngModel)]="selectedCentreCode" (selectionChange)="onCentreChange()" multiple>

        <!--  READ MORE TRIGGER -->
        <mat-select-trigger>
          <ng-container *ngIf="selectedCentreCodesReal.length; else placeholder">
            {{ selectedCentreCodesReal[0] }}
            <span *ngIf="selectedCentreCodesReal.length > 1"
                  class="read-more-text"
                  matTooltip="{{ selectedCentreCodesReal.join(', ') }}">
          + {{ selectedCentreCodesReal.length - 1 }} more
        </span>
          </ng-container>

          <ng-template #placeholder>
            Select Centre
          </ng-template>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_CENTRES" (click)="toggleAllCentres(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <!-- OPTIONS -->
        <mat-option *ngFor="let c of (_centres$ | async)"
                    [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>

      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Gender</mat-label>
      <mat-select [(ngModel)]="selectedGender" (selectionChange)="getGender($event)">
        <mat-option value="All">All</mat-option>
        <mat-option value="Female">Female</mat-option>
        <mat-option value="Male">Male</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Challenges Faced</mat-label>
      <mat-select  [(ngModel)]="selectedChallenges" (selectionChange)="getSelectedChallenges($event)" multiple>
        <mat-select-trigger>
          <ng-container *ngIf="selectedChallengesReal.length">
            {{ selectedChallengesReal[0] }}
            <span *ngIf="selectedChallengesReal.length > 1"
                  class="read-more-text"
                  matTooltip="{{ selectedChallengesReal.join(', ') }}">
              + {{ selectedChallengesReal.length - 1 }} more
            </span>
          </ng-container>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_CHALLENGES" (click)="toggleAllChallenges(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option *ngFor="let challenges of (mChallengesFaced )" [value]="challenges">
          {{ challenges }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Interventions</mat-label>
      <mat-select [ngModel]="selectedIntervention" (selectionChange)="getSelectedInterventions($event)" multiple>
        <mat-select-trigger>
          <ng-container *ngIf="selectedInterventionsReal.length">
            {{ selectedInterventionsReal[0] }}
            <span *ngIf="selectedInterventionsReal.length > 1"
                  class="read-more-text"
                  matTooltip="{{ selectedInterventionsReal.join(', ') }}">
              + {{ selectedInterventionsReal.length - 1 }} more
            </span>
          </ng-container>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_INTERVENTIONS" (click)="toggleAllInterventions(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option *ngFor="let i of (interventions | async)" [value]="i">
          {{ i }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Counsellor Name</mat-label>
      <mat-select [(ngModel)]="selectedCounselorName" (selectionChange)="getCounselorName($event)" multiple>
        <mat-select-trigger>
          <ng-container *ngIf="selectedCounsellorsReal.length">
            {{ selectedCounsellorsReal[0] }}
            <span *ngIf="selectedCounsellorsReal.length > 1"
                  class="read-more-text"
                  matTooltip="{{ selectedCounsellorsReal.join(', ') }}">
              + {{ selectedCounsellorsReal.length - 1 }} more
            </span>
          </ng-container>
        </mat-select-trigger>

        <!-- Select All Option -->
        <mat-option [value]="ALL_COUNSELLORS" (click)="toggleAllCounsellors(); $event.stopPropagation()">
          <strong>Select All</strong>
        </mat-option>

        <mat-option *ngFor="let name of counselorName" [value]="name">
          {{ name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!--    <mat-form-field appearance="outline" class="col-md-4">-->
    <!--      <mat-label>Search</mat-label>-->
    <!--      <input matInput  placeholder="Ex. ium" #input>-->
    <!--    </mat-form-field>-->


    <div class="d-flex justify-content-end gap-2">

      <button class="ms-5" mat-mini-fab color="accent" (click)="searchData()">
        <mat-icon>search</mat-icon>
      </button>
      <button class="mx-2" mat-mini-fab color="accent" (click)="Clear()">
        <mat-icon>clear</mat-icon>
      </button>

<!--      <button class="ms-5" mat-mini-fab color="primary" *ngIf="showHeading" (click)="printDoc()">-->
<!--        &lt;!&ndash; *ngIf="showHeading" &ndash;&gt;-->
<!--        <mat-icon>download</mat-icon>-->
<!--      </button>-->

      <button class="mx-2" mat-mini-fab color="primary" (click)="downloadExcel()">
        <!-- *ngIf="showHeading" -->
        <mat-icon>download</mat-icon>
      </button>

<!--        <div-->
<!--          class="export-button m-l-10"-->
<!--          matTooltip="Download Excel"-->
<!--          (click)="downloadExcel()">-->
<!--          <mat-icon>download</mat-icon>-->
<!--        </div>-->


    </div>

  </div>

  <div #content>
    <div class="d-flex justify-content-between  ">
      <div></div>

      <img src="assets/logo.png" alt="logo">

    </div>

    <div class="text-center text-dark mb-4">
      <h1>Intervention Report</h1>
    </div>
    <div class="text-center">
      <h3 *ngIf="selectedGender"> Gender Selected: {{selectedGender}}</h3>
      <h3 *ngIf="startDate &&endDate">From: {{startDate|date:'dd-MMM-yyyy'}} to {{endDate|date:'dd-MMM-yyyy'}} </h3>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="card">

          <div class="header">
            <h2 class="text-center">Interventions Chart</h2>
          </div>
          <div class="body" *ngIf="mShowInterventionsChart">
            <apx-chart [series]="interventionsChartOptions.series!" [chart]="interventionsChartOptions.chart!"
                       [xaxis]="interventionsChartOptions.xaxis!" [yaxis]="interventionsChartOptions.yaxis!"
                       [colors]="interventionsChartOptions.colors!" [plotOptions]="interventionsChartOptions.plotOptions!"
                       [stroke]="interventionsChartOptions.stroke!" [legend]="interventionsChartOptions.legend!"
                       [grid]="interventionsChartOptions.grid!"
                       [tooltip]="interventionsChartOptions.tooltip!"
                       [dataLabels]="interventionsChartOptions.dataLabels!"></apx-chart>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="page-break-before: always">
        <div class="card">
          <div class="header">
            <h2 class="text-center">Challenges Chart</h2>
          </div>
          <div class="body" *ngIf="mShowChart">
            <apx-chart [series]="areaChartOptions.series!" [chart]="areaChartOptions.chart!"
                       [xaxis]="areaChartOptions.xaxis!" [yaxis]="areaChartOptions.yaxis!"
                       [colors]="areaChartOptions.colors!" [plotOptions]="areaChartOptions.plotOptions!"
                       [stroke]="areaChartOptions.stroke!" [legend]="areaChartOptions.legend!"
                       [grid]="areaChartOptions.grid!"
                       [tooltip]="areaChartOptions.tooltip!" [dataLabels]="areaChartOptions.dataLabels!"></apx-chart>
          </div>
        </div>
      </div>

    </div>

  </div>
  <div class="card">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
    </mat-form-field>
    <div [ngStyle]="tableStyles">
      <table mat-table [dataSource]="dataSource" matSort class="body">
        <!-- Define columns -->
        <ng-container matColumnDef="sr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Sr</th>
          <td mat-cell *matCellDef="let element;let i =index"> {{ i + 1 }} </td>
        </ng-container>
        <ng-container matColumnDef="childName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name</th>
          <td mat-cell *matCellDef="let element"  class="truncate-text" [matTooltip]="element.childName" matTooltipPosition="above"> {{ element.childName }} </td>
        </ng-container>
        <ng-container matColumnDef="sessionDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Date</th>
          <td mat-cell *matCellDef="let element"> {{ (element.date)?.toDate() |date:'dd/MM/yyyy' }} </td>
        </ng-container>
        <ng-container matColumnDef="sessionType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Session Type</th>
          <td mat-cell *matCellDef="let element"  class="truncate-text" [matTooltip]="element.type" matTooltipPosition="above"> {{element.type}} </td>
        </ng-container>
        <ng-container matColumnDef="intervention">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Intervention</th>
          <td mat-cell *matCellDef="let element"  class="truncate-text" [matTooltip]="element.interventions" matTooltipPosition="above"> {{element.interventions}} </td>
        </ng-container>
        <ng-container matColumnDef="challenges">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Challenges</th>
          <td mat-cell *matCellDef="let element"  class="truncate-text" [matTooltip]="element.challengesFaced" matTooltipPosition="above"> {{element.challengesFaced}} </td>
        </ng-container>
        <ng-container matColumnDef="submittedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Counsellor Name</th>
          <td mat-cell *matCellDef="let element"  class="truncate-text" [matTooltip]="element.submittedBy" matTooltipPosition="above"> {{element.submittedBy}} </td>
        </ng-container>
        <!-- Repeat for other columns -->

        <!-- Render rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 500]" showFirstLastButtons></mat-paginator>

  </div>

</div>
